import { reducers } from 'vuex-reducer';

const state = {
  active_dialog: null,
};

const mutations = reducers({
  update: (state, dialog) => ({
    active_dialog: dialog.show ? dialog : null,
  }),
});

const actions = {
  update_dialog: ({ commit }, payload) => {
    commit('update', payload);
  },
};

const getters = {
  get_active_dialog(state) {
    return state.active_dialog;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
